import { ApplicationController, useThrottle } from 'stimulus-use'

export default class extends ApplicationController {
  static throttles = ['onMapChange']
  static values = { ulid: String }

  connect() {
    useThrottle(this, { wait: 1000 })
  }

  onMapChange(event) {
    if (!event.detail?.center) return

    const { lat, lng } = event.detail.center
    const zoom = event.detail.zoom
    if (!this.ulidValue) return

    this.fetchAndUpdateMarkers(lat, lng, zoom)
  }

  async fetchAndUpdateMarkers(lat, lng, zoom) {
    const params = new URLSearchParams({ lat, lng })
    if (zoom != null) params.set('zoom', zoom)
    const url = `/advocates/${this.ulidValue}/nearby.json?${params}`

    try {
      const response = await fetch(url)
      if (!response.ok) return

      const data = await response.json()
      const mapElement = this.element.querySelector('[data-controller="advocate-map-component"]')
      if (!mapElement) return

      const mapController = this.application.getControllerForElementAndIdentifier(
        mapElement,
        'advocate-map-component'
      )

      if (mapController?.updateMarkers) {
        mapController.updateMarkers(data.markers)
      }
    } catch (e) {
      // Silently ignore fetch errors (e.g. navigating away)
    }
  }
}
